import { routes } from "./routes.constatns";
import { Navigate, Route } from "react-router-dom";
import { useEffect } from "react";
import App from "../App";
import { Home } from "../components";
import { OrdersHome } from "../components/Orders/OrdersHome";
import OrdersDetailsHome from "../components/OrdersDetails/OrdersDetailsHome";
import { PreviewFileDataRoute } from "../components/OrdersDetails/PreviewFileData";
import { ReviewMappingsRoute } from "../components/OrdersDetails/ReviewMappingsModal";
import { QualityFramework } from "../components/QualityFramework";
import { CreateNewRequest } from "../components/QualityFramework/CreateNewRequest/CreateNewRequest";
import { AssignUsers } from "../components/QualityFramework/AssignUsers/AssignUsers";
import { CheckList } from "../components/QualityFramework/CheckList/CheckList";
import { UserManagement } from "../components/UserManagement";
import { LAAP } from "../components/LAAP/LAAP";

const isURLAllowed = process.env.REACT_APP_URL_BASE_ALLOW_HOME_URL === "true";
const externalUrl = process.env.REACT_APP_URL_REG_ALL;

// Redirects to external URL when home URL is not allowed
const RedirectToExternal = () => {
  useEffect(() => {
    window.location.href = externalUrl;
  }, []);

  return null;
};
export const AppRoutes = (
  <Route path={routes.root} element={<App />}>
    {isURLAllowed ? (
      <>
        <Route index element={<Navigate to={`/${routes.home}`} />} />
        <Route path={routes.home} element={<Home />} />
        <Route path={routes.orders} element={<OrdersHome />} />
        <Route path={routes.orderDetails} element={<OrdersDetailsHome />}>
          <Route
            path={routes.orderDetailsPreview}
            element={<PreviewFileDataRoute />}
          />
          <Route
            path={routes.orderDetailsReviewMappings}
            element={<ReviewMappingsRoute />}
          />
        </Route>
        <Route path={routes.qualityFramework}>
          <Route index element={<QualityFramework />} />
          <Route path="create" element={<CreateNewRequest />} />
          <Route path="create/assign-users" element={<AssignUsers />} />
          <Route path="check-list" element={<CheckList />} />
        </Route>
        <Route path={routes.laap} element={<LAAP />} />
        <Route path={routes.userManagement} element={<UserManagement />} />
      </>
    ) : (
      <Route path="*" element={<RedirectToExternal />} /> // Redirect to default URL
    )}
  </Route>
);

export default AppRoutes;
